export const IS_REQ = 'is required';

export const getRequiredError = (label) => `${label} ${IS_REQ}`;
export const getMaxError = (label, limit) => `${label} cannot be greater than ${limit} characters`;
export const getMinError = (label, limit) => `${label} cannot be less than ${limit} characters`;

export const REQUIRED_ERROR = (label) => getRequiredError(label);
export const MAX_ERROR = (label, limit) => getMaxError(label, limit);
export const MIN_ERROR = (label, limit) => getMinError(label, limit);

export const CTC_NAME_REGEX_ERROR = (label) => `${label} can be alphanumeric and optionally contain special characters in between. Valid characters include ., ,, -, _, or space`;

export const PASSWORD_REGEX_ERR = 'Password must contain 4 out of 4 of the following: uppercase, lowercase, number, special character.Valid characters include A-Z, a-z, 0-9 ,!, @, # ,$ ,%,* _, -,^';
export const PASSWORD_COMMON_REGEX_ERR = 'This is a common password and cannot be used';
export const PASSWORD_NOT_MATCH_ERR = 'Passwords must match';
